import React from 'react';
import { Flame, Pencil, Bird, Swords, Timer, Trophy, Zap, Crown, Award, Star, Heart, Medal, CalendarCheck, Infinity, CircleStar } from 'lucide-react';
import DiscordIcon from '../components/DiscordIcon.tsx';

/** Returns the achievement-specific icon for use in cards and toasts. */
export function getAchievementIcon(id: string, size = 20): React.ReactNode {
  switch (id) {
    case 'daily_streak':      return <Flame  size={size} strokeWidth={1.6} />;
    case 'puzzle_author':     return <Pencil size={size} strokeWidth={1.8} />;
    case 'puzzle_like':       return <Heart  size={size} strokeWidth={1.6} />;
    case 'first_daily_solver':return <Bird   size={size} strokeWidth={1.6} />;
    case 'endless_solves':    return <Infinity size={size} strokeWidth={1.6} />;
    case 'multiplayer_wins':  return <Swords size={size} strokeWidth={1.6} />;
    case 'tournaments_played':return <CircleStar size={size} strokeWidth={1.6} />;
    case 'speedrun_time':     return <Timer  size={size} strokeWidth={1.6} />;
    case 'top1_community':    return <Star   size={size} strokeWidth={1.6} />;
    case 'top1_speedrun':     return <Zap    size={size} strokeWidth={1.6} />;
    case 'top1_elo':          return <Crown  size={size} strokeWidth={1.6} />;
    case 'optimizer':         return <Medal  size={size} strokeWidth={1.6} />;
    case 'anniversary':       return <CalendarCheck size={size} strokeWidth={1.6} />;
    case 'join_discord':      return <DiscordIcon size={size} />;
    default:                  return <Award  size={size} strokeWidth={1.6} />;
  }
}
